import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Geojson } from '../Appcode/geowork';

@Injectable({
  providedIn: 'root'
})
export class GeoMapXService {

  constructor() { }

  private CurrentMark = new BehaviorSubject<Geojson>({type:'',geometry: {type:'',coordinates:[0,0]}});
  CurrentMark$: Observable<Geojson> = this.CurrentMark.asObservable();
  SetCurrentMark(Model: Geojson) {
    this.CurrentMark.next(Model);
  }
}
